import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-warning-toast',
  template: `
    <div class="padding-8 aid-layout-row aid-layout-align-space-between-center">
      <div class="aid-layout-row aid-layout-gap-8">
        <div
          class="padding-left-16 aid-layout-row aid-layout-align-center-center"
        >
          <mat-icon svgIcon="alert_triangle"></mat-icon>
        </div>
        <div class="mat-subtitle-2 white">
          {{ title | translate | uppercase }}
        </div>
        <div class="mat-subtitle-2 white">
          {{ message | translate | sentancecase }}
        </div>
      </div>
      <button mat-icon-button (click)="close.emit()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  `,
  styleUrls: ['./warning-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WarningToastComponent implements OnInit {
  @Input() message?: string;
  @Input() title?: string;
  @Output() close = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
